<template>
  <div class="h-full risk overflow-y-auto overflow-x-hidden">
    <div class="m-10px">
      <div>
        <div class="flex justify-start item-start mb-10px">
          <img src="../../assets/images/titleIcon.png" alt="" />
          <span class="text-16px text-white custom-shadow ml-4px">
            风险区域统计
          </span>
        </div>
        <div class="flex justify-between items-center">
          <div
            v-for="(item, index) in areaList"
            :key="index"
            class="flex flex-col justify-center items-center"
          >
            <div>
              <img :src="item.img" alt="" />
            </div>
            <div :class="['text-white', 'text-20px', 'font-bold', item.code]">
              {{ item.count }}
            </div>
            <div class="text-white text-14px area-textshadow mt-4px">{{ item.name }}</div>
          </div>
        </div>
      </div>
      <div>
        <div class="flex justify-start item-start mt-20px mb-10px">
          <img src="../../assets/images/titleIcon.png" alt="" />
          <span class="text-16px text-white custom-shadow ml-4px">
            风险管控分析
          </span>
        </div>

        <div class="w-full h-48px info-right mb-5px">
          <div class="w-full h-full p-2px z-9999 relative">
            <div class="w-full h-full flex justify-around items-center">
              <div
                :class="[
                  'text-[#8fd5db]',
                  'text-14px',
                  'flex-1',
                  'text-center',
                  'cursor-pointer',
                  currentIndex === index ? 'active-type toggle-textshadow' : '',
                ]"
                v-for="(item, index) in typeList"
                :key="index"
                @click="handleTypeClick(index)"
              >
                {{ item.name }}
              </div>
            </div>
          </div>
        </div>
        <div>
          <line-chart :type="type"></line-chart>
        </div>
      </div>
      <div>
        <div class="flex justify-start item-start mt-10px">
          <img src="../../assets/images/titleIcon.png" alt="" />
          <span class="text-16px text-white custom-shadow ml-4px">
            全厂隐患分析
          </span>
        </div>
        <div>
          <bar-chart></bar-chart>
        </div>
        <div>
          <el-row :gutter="10">
            <el-col :span="12" v-for="(item, index) in hiddenRangeList" :key="index">
              <div
                class="h-30px flex justify-between items-center mb-10px bg-[#0b4966] px-10px custom-point relative"
              >
                <div class="flex justify-start items-center ">
                  <div :class="['w-8px', 'h-8px', 'rounded-full', `${item.clr}`, 'mr-10px']"></div>
                  <div class="text-12px text-[#8ba7b5]">{{ item.name }}</div>
                </div>
                <div class="text-16px text-[#ffffff]">{{ item.count }}</div>
              </div>
            </el-col>
          </el-row>
        </div>
        <el-row :gutter="10">
          <el-col :span="12">
            <board-chart
              id="riskHiddenDnagerBoardChart1"
              :value="0"
              title="风险排查完成率"
            ></board-chart>
          </el-col>
          <el-col :span="12">
            <board-chart
              id="riskHiddenDnagerBoardChart2"
              :value="0"
              title="隐患治理完成率"
            ></board-chart>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import { AreaApi } from '@wiz-api/area-management'
import LineChart from '../tool/riskCharts/LineChart'
import BarChart from '../tool/riskCharts/BarChart'
import BoardChart from '../tool/riskCharts/BoardChart'

const areaApi = new AreaApi()

export default {
  name: 'risk-hidden-danger',
  components: {
    LineChart,
    BarChart,
    BoardChart,
  },
  props: {
    customProps: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      currentIndex: 0,
      type: 'department',
      hiddenRangeList: [
        {
          name: '已整改',
          code: 'changed',
          count: 0,
          clr: 'bg-[#00bcc8]',
        },
        {
          name: '未整改',
          code: 'nochanged',
          count: 0,
          clr: 'bg-[#61e29d]',
        },
        {
          name: '整改中',
          code: 'changing',
          count: 0,
          clr: 'bg-[#f4d982]',
        },
        {
          name: '超期未整改',
          code: 'timeoutnochange',
          count: 0,
          clr: 'bg-[#e88d6b]',
        },
      ],
      typeList: [
        {
          type: 'department',
          name: '部门',
        },
        {
          type: 'area',
          name: '区域',
        },
      ],
      areaList: [
        {
          name: '重大风险',
          code: 'importantRisk',
          img: require('../../assets/images/risk/importantRisk.png'),
          count: 0,
        },
        {
          name: '较大风险',
          code: 'largerRisk',
          img: require('../../assets/images/risk/largerRisk.png'),
          count: 0,
        },
        {
          name: '一般风险',
          code: 'normalRisk',
          img: require('../../assets/images/risk/normalRisk.png'),
          count: 0,
        },
        {
          name: '低风险',
          code: 'lowRisk',
          img: require('../../assets/images/risk/lowRisk.png'),
          count: 0,
        },
      ],
    }
  },
  mounted() {},
  watch: {
    'customProps.sceneId': {
      handler(newVal) {
        // 获取风险区域统计数据
        this.getAreaValues(newVal)
      },
      immediate: true,
    },
  },
  methods: {
    handleTypeClick(index) {
      this.currentIndex = index
      this.type = index === 0 ? 'department' : 'area'
    },
    // 获取风险区域统计数据
    async getAreaValues(newVal) {
      const [err, res] = await areaApi.getAreaRiskLevelStatistic({ senceId: newVal })
      if (!err) {
        this.areaList[0].count =
          res.find((item) => {
            return item.name === '重大风险'
          })?.count || 0
        this.areaList[1].count =
          res.find((item) => {
            return item.name === '较大风险'
          })?.count || 0
        this.areaList[2].count =
          res.find((item) => {
            return item.name === '一般风险'
          })?.count || 0
        this.areaList[3].count =
          res.find((item) => {
            return item.name === '低风险'
          })?.count || 0
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../assets/styles/loading.scss';
@import '../../assets/styles/shadow.scss';
// 四个风险等级渐变色样式
.importantRisk {
  background: linear-gradient(to top, #ff0000 10%, #8f1919 20%, #eb7b7b 30%, #f7feff 100%);
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.largerRisk {
  background: linear-gradient(to top, #ff5c00 10%, #8f3519 20%, #ebaa7b 30%, #f7feff 100%);
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.normalRisk {
  background: linear-gradient(to top, #ebff00 10%, #8f8a19 20%, #ebe07b 30%, #f7feff 100%);
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.lowRisk {
  background: linear-gradient(to top, #00c5ff 10%, #196f8f 20%, #7bcdeb 30%, #f7feff 100%);
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

::v-deep .info-right {
  background: url('../../assets/images/risk/tabToggle.png');
  background-size: 100% 100%;
}

// 激活border
.active-type {
  position: relative;
  font-size: 16px;
  &::before {
    position: absolute;
    content: '';
    bottom: -10px;
    left: 54px;
    background: #00ffff;
    width: 50px;
    height: 2px;
  }
  &::after {
    position: absolute;
    content: '';
    width: 0;
    height: 0;
    bottom: -8px;
    left: 74px;
    border-bottom: 5px solid #00ffff;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
  }
}

// 隐患分析-左上角伪元素
.custom-point {
  &::before {
    position: absolute;
    content: '';
    top: 0;
    left: 0;
    width: 4px;
    height: 3px;
    background-color: #9bb8c7;
  }
}

// 滚动条样式
.risk::-webkit-scrollbar {
  width: 5px !important;
  height: 2px !important;
  background: rgba(24, 41, 72, 0.4);
}

.risk::-webkit-scrollbar-thumb {
  border-radius: 10px !important;
  background: #02cfe4;
}
.risk::-webkit-scrollbar-track {
  border-radius: 10px !important;
  background: rgba(24, 41, 72, 0.4);
}
</style>
